const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getLeadLoginUrlApi = async (leadId, accessMode = null, ttl = null) => {
  const token = localStorage.getItem('token');
  const queryParams = new URLSearchParams();

  if (accessMode) queryParams.set('access_mode', accessMode);
  if (ttl !== null) queryParams.set('ttl', String(ttl));

  const query = queryParams.toString() ? `?${queryParams.toString()}` : '';

  if (!token) {
    console.error('[getLeadLoginUrlApi] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/${leadId}/get-login-url${query}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error(`[getLeadLoginUrlApi] Ошибка получения URL для входа для лида ${leadId}:`, errorData);
      throw Object.assign(
        new Error(errorData.message || 'Не удалось получить URL для входа.'),
        errorData,
        { statusCode: response.status }
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`[getLeadLoginUrlApi] Сетевая или другая ошибка при получении URL для входа для лида ${leadId}:`, error);
    throw error;
  }
};
